<template>
    <div >
        <my-form
        class="form-page"
        table
        label-width="160px"
        >
            <div>
                <span style="font-size:18px;font-weight:bold;line-height:50px;">招标项目设置</span>   
            </div>
            <el-card >
                <my-form-item-group :title="zbproject.zbproname+ '——招标项目设置'">
                    <el-form-item
                    :label="'是否报名'"
                    :prop="zbproject.extsfbm"
                    class="table-full-row"
                    >
                        <el-switch
                            v-model="zbproject.extsfbm"
                            active-value="1" inactive-value="0" @change="changesfbm()">
                        </el-switch>
                        <my-tag type="danger" style="margin-left:10px" v-if="zbproject.detail!==null">
                             {{zbproject.detail}}
                        </my-tag>
                       
                    </el-form-item>
                </my-form-item-group>
            </el-card>
            <div class="bdsz">
                <div >
                    <span style="font-size:18px;font-weight:bold;line-height:50px;">标段设置</span>   
                </div>
                <el-card v-for="(item,index) in lizbbd" :key="item.bdcode">
                    <my-form-item-group 
                    :title="item.bdname + '——标段设置(二阶段)'" 
                    label-width="220px" v-if="item.linkbdcode!==''&&item.linkbdcode!==null">
                        <el-form-item
                        label="解密截止时间"
                        :prop="item.extjmjstime"
                        >
                            {{item.extjmjstime}}
                            <el-button type="text" @click="edit(item.bdcode,item.extjmjstime,item.extkbtime)" style="margin-left:20px;font-size:14px">
                                修改
                            </el-button>
                        </el-form-item> 
                        <el-form-item
                        label="是否评定分离"
                        :prop="item.detail"
                        >
                            <el-switch
                                v-model="item.detail" active-value="pdfl" inactive-value="null" @change="changepdfl(item.bdcode)">
                            </el-switch>
                        </el-form-item> 
                    </my-form-item-group>
                    <my-form-item-group 
                    :title="item.bdname + '——标段设置'" 
                    label-width="220px"
                    v-if="item.linkbdcode==''||item.linkbdcode==null">
                        <el-form-item
                        label="解密截止时间"
                        :prop="item.extjmjstime"
                        >
                            {{item.extjmjstime}}
                            <el-button type="text" @click="edit(item.bdcode,item.extjmjstime,item.extkbtime)" style="margin-left:20px;font-size:14px">
                                修改
                            </el-button>
                        </el-form-item> 
                        <el-form-item
                        label="是否评定分离"
                        :prop="item.detail"
                        >
                            <el-switch
                                v-model="item.detail" active-value="pdfl" inactive-value="null" @change="changepdfl(item.bdcode)">
                            </el-switch>
                        </el-form-item> 
                    </my-form-item-group>
                    
                </el-card>
            </div>
            <template slot="btn" slot-scope="scope">
               <span></span>
            </template>
        </my-form>
         <my-dialog title="修改解密截至时间" v-model="dialogVisible" width="1150px" >
            <edit :bdcode="bdcode" :extjmjstime="extjmjstime" :extkbtime="extkbtime" v-if="dialogVisible" @cancle="dialogClose()"></edit>
        </my-dialog>
    </div>
</template>

<script>
import edit from './edit.vue'
export default {
    components: { edit },
    // mixins: [LIST_PAGE_MIXIN, DIALOG_LIST_PAGE_MIXIN],
    props: {
        zbprocode: {
            type: String,
            default:''
        },
    },
    data() {
        return{
            proname:'',
            zbproject:[],
            lizbbd:[],
            isbaoming:'',
            ispdfl:'',
            dialogVisible:false,
            bdcode:'',
            extjmjstime:'',
            extkbtime:''
        }
    },
    computed: {
        
    },
    watch: {
    
    },
    methods: {
        init() {
            this.$get(`${this.getGetters('mngUrl')}/Zbdl/tuihui/console.json`,{zbprocode:this.zbprocode}, (data, res) => {
                this.lizbbd=data.lizbbd
                this.zbproject=data.zbproject
            });
        },
        changesfbm() {
            let that = this
				this.$confirm('是否确认修改?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					callback: function (action, instance) {
						if (action == 'confirm') {
							var obj = {};
							that.$post(`${that.getGetters('mngUrl')}/Zbdl/tuihui/updatesfbm.json`,{zbprocode:that.zbprocode}, function (data, res) {
                                ShowMsg(res.msg,'success');
                                that.init()
							})
						}else {
                            that.init()
                        }
                        that.init()
					}
				})
        },
        changepdfl(bdcode) {
            let that = this
			this.$confirm('是否确认修改?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				callback: function (action, instance) {
					if (action == 'confirm') {
						var obj = {};
						that.$post(`${that.getGetters('mngUrl')}/Zbdl/tuihui/updapdfl.json`,{bdcode:bdcode}, function (data, res) {
                            ShowMsg(res.msg,'success');	
                            that.init()
						})
					}else {
                        that.init()
                    }
				}
			})	
		},
        changejmsj(bdcode,tbwjjmjzsj) {
            let that = this
			this.$confirm('是否确认修改?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				callback: function (action, instance) {
					if (action == 'confirm') {
						var obj = {};
						$.post(`${that.getGetters('mngUrl')}/Zbdl/tuihui/updatejmjzsj.json`,{
                            bdcode:bdcode,
                            tbwjjmjzsj:tbwjjmjzsj
                        }, function (data, res) {
                            if(res.code == 'v') {
                               ShowMsg(res.msg,'success'); 
                            }else {
                                ShowMsg(data.msg); 
                                that.init()
                            }

                            // 
                            // 
			            })
					}else {
                        that.init()
                    }
				}
			})	
        },
        edit(bdcode,extjmjstime,extkbtime) {
            this.bdcode=bdcode
            this.extjmjstime=extjmjstime
            this.extkbtime=extkbtime
            this.dialogVisible=true
        },
        dialogClose() {
            this.dialogVisible=false
            this.init()
        }
    },
    created() {
        this.init()
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
/deep/ .el-collapse-item__header { 
    height: 64px;
    line-height: 20px;
}
/deep/ .el-card__header {
    background-color: #EBEEF5;
}
/deep/ .el-input {
    width:200px
}
.el-card{
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 30px;
}
.el-form{
    border-left:none!important;
    border-bottom:none!important;
}
.form-item-group_body{
    border-left: 1px solid #E8E8E8!important;
    }
.my-form-item-group{
    border-left: 1px solid #E8E8E8!important;
    border-top: 1px solid #E8E8E8!important;
}
/deep/.btn-row {
    border-right: 0px!important;
}
.bdsz {
    width: 100%;
    height: 400px;
    overflow: auto;
}
</style>
